import DatePicker from 'vue2-datepicker';
import datepicker from '@/custom';
import moment from 'moment-timezone';

//restful api
import { detect as webcastle } from '@/service/api/webcastle'

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv : false,
});

const i18n_fields = {
  EN: [
    { key: 'id', label: '#.', sortable: true, thStyle: 'width: 5%' },
    { key: 'created_at', label: 'Date', sortable: true, thStyle: 'width: 10%' },
    { key: 'remote_addr', label: 'Attacker', sortable: true, thStyle: 'width: 10%' },
    { key: 'target', label: 'Target', sortable: true, thStyle: 'width: 10%' },
    { key: 'protocol', label: 'Protocol', sortable: false, thStyle: 'width: 10%' },
    { key: 'method', label: 'Method', sortable: false, thStyle: 'width: 10%' },
    { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 10%' },
    { key: 'uri', label: 'URI', sortable: false, thStyle: 'width: 10%' },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: true, thStyle: 'width: 5%' },
    { key: 'created_at', label: '날짜', sortable: true, thStyle: 'width: 10%' },
    { key: 'remote_addr', label: '공격자', sortable: true, thStyle: 'width: 10%' },
    { key: 'target', label: '대상', sortable: true, thStyle: 'width: 10%' },
    { key: 'protocol', label: '프로토콜', sortable: false, thStyle: 'width: 10%' },
    { key: 'method', label: '통신 방식', sortable: false, thStyle: 'width: 10%' },
    { key: 'is_block', label: '응답', sortable: false, thStyle: 'width: 10%' },
    { key: 'uri', label: 'URI', sortable: false, thStyle: 'width: 10%' },
  ]
}

export default {
  data: () => {
    return {
      datepicker,
      show: true,
      so : default_opt(),
      sync : { interval : 15, stop : false, th : undefined },
    }
  },
  components: {
    DatePicker,
  },
  computed: {
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    },
    fields() {
      return i18n_fields[this.i18n];
    }
  },
  methods: {
    set() { this.so.opt.from = moment().format('YYYY-MM-DD'); this.so.opt.to = moment().format('YYYY-MM-DD'); },
    reset() { this.so = default_opt(); this.so.opt.from = ''; this.so.opt.to = ''; this.refresh(); },
    refresh() {
      if((!this.sync.stop || this.so.adv) && this.$refs._list) {
        this.$refs._list.refresh();
        console.log('webcastle log refresh', new Date());
      }
    },
    getRowCount () { return this.so.totalRows || 0; },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
        offset : this.so.currentPage-1 || 0,
        limit :  Number(this.so.perPage),
        body: {
          and : [],
          sort : [ { name : "id", op : "desc" } ]
        }
      }
      so.offset = so.offset * so.limit;
      if(so.opt.from) { so.opt.from = moment(so.opt.from).format(); }
      if(so.opt.to) { so.opt.to = moment(so.opt.to).add(1, 'day').format(); }
      if(this.so.adv && so.opt && !(so.opt.to && so.opt.from)) { this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)('Search Error', 'Range is not valid'); }
      if(this.so.adv){
        so.body.and = [];
        Object.keys(this.so.opt).forEach(k => {
          if(this.so.opt[k] === '') { return; }
          if(!(k == 'from' || k == 'to' || k == 'is_block')) { so.body.and.push({ "name" : k, "value" : this.so.opt[k], "op" : 'like' }) }
          else {
            if(k == 'from') { so.body.and.push({ "name" : 'created_at', "value" : moment(this.so.opt[k]), "op" : '>=' }) }
            if(k == 'to') { so.body.and.push({ "name" : 'created_at', "value" : moment(this.so.opt[k]).add(1, 'day'), "op" : '<' }) }
            if(k == 'is_block' && this.so.opt[k] == '1') { so.body.and.push({ "name" : 'is_block', "value" : true, "op" : '=' }) }
            if(k == 'is_block' && this.so.opt[k] == '0') { so.body.and.push({ "name" : 'is_block', "value" : false, "op" : '=' }) }
          }
        })
      }else {
        //일부 키워드 검색
        if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }
      }
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
        return webcastle.listDetect(so).then(rs => {
        this.so.totalRows = rs.total;
        if(rs.body > 0){
          for (let i = 0; i < rs.body.length; i++) {
            let r = rs.body[i];
            if(!r.headers) { r.reqTarget = ''; return '' }
            const headers = r.headers.split('\n');
            let reqTarget = '';
            for (let i = 0; i < headers.length; i++) {
              const line = headers[i].replace(/\s/, '').toLowerCase();
              if(line.indexOf('host') == -1) { continue;  }
              reqTarget = line.replace('host:', '');
            }
            r.reqTarget = reqTarget && reqTarget != r.target ? reqTarget : '';
          }
        }
        return rs.body;
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    pause: function() { this.sync.stop = !this.sync.stop; this.refresh(); if(this.sync.stop) { this.so.adv = false; } },
    goDetail: function(item) { console.log(item); this.$router.push(`log/${item.id}`); },
    hideList: function(e) {
      this.show = !e; console.log('dashboard.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    }
  },
  created: function() { console.log('dashboard.vue', 'created'); },
  destroyed: function() { console.log('dashboard.vue', 'destroyed'); this.sync.th = undefined; },
  mounted: function() { console.log('dashboard.vue', 'mounted'); },
}